import React from 'react';
import { connect } from 'react-redux';
import { create } from '../Actions/store-object-category';
import Routes from '../Shared/routes';
import AddStoreObjectEdit from '../Components/StoreObjectCategory/Item';
import { IStoreObjectCategoryEdit } from '../Shared/interfaces';
import NewsSource from '../Entities/NewsSource';
import NewsCategory from '../Entities/NewsCategory';
import Loading from '../Components/Loading';
import CarsStoreObject from '../Entities/CarsStoreObject';
import { FILL_PARAMS_ERROR } from '../Shared/errors';


interface IProps {
    isLoading: boolean;
    error: number;
    create: (data: IStoreObjectCategoryEdit) => void;
    history: any;
}

interface IState {
    error: number | null;
}

class EditStoreObjectCategory extends React.Component<IProps, IState> {

    state = {
        error: null
    }

    onSubmit = async (data: IStoreObjectCategoryEdit) => {
        if (!(data.name)) {
            this.setState({
                error: FILL_PARAMS_ERROR
            });
        }
        else {
            await this.props.create(data);
            if (!this.props.error) {
                this.props.history.push(Routes.STORE_OBJECT_CATEGORY_LIST)
            }
        }
    }

    render() {
        if (this.props.isLoading) {
            return <Loading/>;
        }
        return (
            <AddStoreObjectEdit
                error={this.props.error || this.state.error}
                isLoading={this.props.isLoading}
                onSubmit={this.onSubmit}
            />
        );
    }
}

function bindAction(dispatch: any) {
    return {
        create: (data: IStoreObjectCategoryEdit) => dispatch(create(data)),
    };
}

const mapStateToProps = (state: any) => {
    return {
        isLoading: state.storeObjectCategory.isLoading,
        error: state.storeObjectCategory.error
    }
}

export default connect(
    mapStateToProps,
    bindAction
)(EditStoreObjectCategory);
